export default __webpack_public_path__ + "static/media/PlusCreditOrange.9ca7c7d4.svg";